export default "__VITE_ASSET__BrDcjSfi__"